export const FULL_WIDTH_TASK_FIELDS = ['title', 'description', 'attachments', 'comment'];
